const Parser = require('./Parser');
const error = require('./error');
const { errors } = require('@transfeeradev/api-enums');

class Validation {
  constructor(data) {
    this._data = data;
    this._parser = new Parser(this._data);
  }

  validate() {
    const firstLine = this._parser.getFirstLine();

    if (firstLine.length > 1) {
      return error(errors.ptBr.she.WRONG_FIRST_LINE);
    }

    if (!firstLine[0]) {
      return error(errors.ptBr.she.WRONG_FIRST_LINE);
    }

    return null;
  }
}

module.exports = Validation;
